import { Tooltip } from 'ui/tooltip';
import {
  StyledDataContextContent,
  StyledDataContextTitle,
  StyledDataContextCaption,
  StyledDataContextInnerWrapper,
  StyledSecondaryContentText,
  StyledDataContextDisabledCaption,
  StyledLastRefreshDays,
} from 'ui/dataContextMenu/DataContextMenu.styled';
import { DataContextField } from 'ui/dataContextMenu/DataContextField';
import { DataContextSampleField } from './DataContextSampleField';
import { DataContextMenuProps } from './types';
import { getDaysAgo } from './utils';

export const FieldTypeDisplayName = {
  system: 'System Event',
  user: 'User Event',
  purchase: 'Purchase Event',
  custom: 'Custom Event',
};

export const DataContextMenu = ({
  description,
  event,
  fieldDisplayName,
  fieldData,
  fieldHeader,
  isError,
  isLoading,
  sampleValue,
  fieldFooter,
  isLastRefreshTooltipEnabled = true,
}: DataContextMenuProps) => {
  let daysAgo = 0;
  if (fieldFooter?.date) {
    daysAgo = getDaysAgo(fieldFooter.date, new Date());
  }

  return (
    <StyledDataContextContent data-test={`${fieldDisplayName}-data-context-menu`}>
      <div>
        <StyledDataContextTitle>{fieldDisplayName}</StyledDataContextTitle>
        <StyledDataContextCaption>{FieldTypeDisplayName[event]}</StyledDataContextCaption>
      </div>
      {description && <StyledSecondaryContentText>{description}</StyledSecondaryContentText>}
      {sampleValue && <DataContextSampleField sampleValue={sampleValue} />}
      <StyledDataContextInnerWrapper>
        <DataContextField
          fieldDisplayName={fieldDisplayName}
          fieldData={fieldData}
          fieldHeader={fieldHeader}
          isLoading={isLoading}
          isError={isError}
        />
      </StyledDataContextInnerWrapper>
      {fieldFooter?.date && (
        <StyledDataContextDisabledCaption data-test={`${fieldDisplayName}-last-updated`}>
          <div>{fieldFooter.text}</div>
          <Tooltip
            isEnabled={isLastRefreshTooltipEnabled}
            tooltipContent={fieldFooter.date.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          >
            <StyledLastRefreshDays
              data-test="last-refresh-days"
              data-is-last-refresh-tooltip-enabled={isLastRefreshTooltipEnabled}
            >{` ${daysAgo} day${daysAgo === 1 ? '' : 's'} ago`}</StyledLastRefreshDays>
          </Tooltip>
        </StyledDataContextDisabledCaption>
      )}
    </StyledDataContextContent>
  );
};
